export default {
  ROUTE_HOME: 'dae/relatorios'
}



// WEBPACK FOOTER //
// ./src/constants/ba/dadosEstado/financeiro.js